/**
 * @file The purchase album reducer.
 */

import {
  // TODO: Refactor this to use single select/deselect identity.
  // @see discover-album-folder-reducer.js.
  SELECT_IDENTITY_FOR_PURCHASE,
  DESELECT_IDENTITY_FOR_PURCHASE,
  SELECT_IDENTITY_FOR_JOIN,
  DESELECT_IDENTITY_FOR_JOIN,
  CHECKOUT_REQUEST,
  CHECKOUT_SUCCESS,
  CHECKOUT_FAILURE,
} from '../actions/purchase-album';
import { IDENTITY_CREATE_SUCCESS } from '../actions/identity-create';

const initialState = {
  identitiesForPurchase: [],
  identitiesForJoin: [],
  loading: false,
  error: '',
  success: false,
  purchasedUrl: '',
};

const purchaseAlbumReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELECT_IDENTITY_FOR_PURCHASE:
    case IDENTITY_CREATE_SUCCESS:
      if (
        state.identitiesForPurchase.find(({ id }) => id === action.identity.id)
      ) {
        return state;
      }

      return {
        ...state,
        identitiesForPurchase: [
          ...state.identitiesForPurchase,
          action.identity,
        ],
      };

    case DESELECT_IDENTITY_FOR_PURCHASE:
      return {
        ...state,
        identitiesForPurchase: state.identitiesForPurchase.filter(
          identity => identity.id !== action.identity.id,
        ),
      };

    case SELECT_IDENTITY_FOR_JOIN:
      if (state.identitiesForJoin.find(({ id }) => id === action.identity.id)) {
        return state;
      }

      return {
        ...state,
        identitiesForJoin: [...state.identitiesForJoin, action.identity],
      };

    case DESELECT_IDENTITY_FOR_JOIN:
      return {
        ...state,
        identitiesForJoin: state.identitiesForJoin.filter(
          identity => identity.id !== action.identity.id,
        ),
        identitiesForPurchase: state.identitiesForPurchase.filter(
          identity => identity.id !== action.identity.id,
        ),
      };

    case CHECKOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
        purchasedUrl: '',
      };

    case CHECKOUT_SUCCESS:
      return {
        ...state,
        identitiesForJoin: [],
        identitiesForPurchase: [],
        loading: false,
        error: '',
        success: true,
        purchasedUrl: action.purchasedUrl,
      };

    case CHECKOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message || action.error,
        success: false,
      };

    default:
      return state;
  }
};

export { initialState };
export default purchaseAlbumReducer;
